import api from './../api';

export default {
    namespaced: true,

    state: {
        count: 0,
        items: [],
    },
    getters: {},
    actions: {
        count(store) {
            api.get('notification/count').then(response => {
                store.commit('setCount', response.data.count);
            }).catch(error => {
                // todo: show error ???
            });
        },
        load(store, params = {}) {
            return new Promise((resolve, reject) => {
                const page = params.page === undefined ? 1 : params.page;
                api.post('notification/list/' + page + '/10', {}).then(response => {
                    store.commit('setItems', response.data);
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        supportedTypes() {
            return new Promise((resolve, reject) => {
                api.get('notification/supported-notifications').then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        update(store, params) {
            return new Promise((resolve, reject) => {
                api.put('notification/' + params.id, params).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
    },
    mutations: {
        setCount(state, data) {
            state.count = data;
        },
        setItems(state, data) {
            state.items = data;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/notifications.js